module.exports = __webpack_public_path__ + "static/media/instructivo.2fa2109d.mp4";